import { materialListApi } from '@/api/my/material'
import { MATERIAL_VIEW_FULL } from '@/api/static_api'
import { getToken } from '@/auth/auth'
// initial state
const state = {
  materialGroupList: []
}

// getters
const getters = {
  materialGroupList: state => state.materialGroupList
}

// actions
const actions = {
  // 材料列表
  materialGroupListAction ({ commit }) {
    return new Promise((resolve, reject) => {
      materialListApi().then(response => {
        if (response.status === '2000') {
          response.data.forEach(m => {
            let srcList = []
            m.materialList.forEach(materia => {
              const src = {
                src: MATERIAL_VIEW_FULL + '&Token=' + getToken() + '&id=' + materia.id
              }
              srcList.push(src)
            })
            m.previewerSrcList = srcList
          })
          commit('setMaterialGroupList', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// mutations
const mutations = {
  setMaterialGroupList (state, materialGroupList) {
    state.materialGroupList = materialGroupList
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/my/material.js